export enum FetchStatus {
  Idle = 'idle',
  Loading = 'loading',
  Error = 'error',
  Success = 'success',
  /**
   * Loading은 새로운 요소를 API에서 가져오고 있는 상태를 의미합니다.
   * 반면, MoreLoading은 이미 이전에 API에서 데이터를 불러와 store에 존재하는 요소에
   * 데이터를 추가적으로 덧붙이기 위해 API에서 데이터를 가져오고 있는 상태를 의미합니다.
   */
  MoreLoading = 'more_loading',
}
